var render, staticRenderFns
import script from "./Loading.vue?vue&type=script&lang=tsx&"
export * from "./Loading.vue?vue&type=script&lang=tsx&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=6ae436b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae436b8",
  null
  
)

component.options.__file = "Loading.vue"
export default component.exports